import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgbDatepickerModule, NgbModalModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { OffersGroupReportComponent } from '../reports/offers-group-report/offers-group-report.component';
import { OffersReportComponent } from '../reports/offers-report/offers-report.component';
import { MeetingGroupReportComponent } from '../reports/meeting-group-report/meeting-group-report.component';
import { MeetingReportComponent } from '../reports/meeting-report/meeting-report.component';
import { CombinedGroupReportComponent } from '../reports/combined-group-report/combined-group-report.component';
import { RecommendationGroupReportComponent } from '../reports/recommendation-group-report/recommendation-group-report.component';

import { ReportPanelRoutingModule } from './report-panel-routing.module';


@NgModule({
  imports: [
    CommonModule,
    ReportPanelRoutingModule,
    HttpClientModule,
    NgbDatepickerModule,
    NgbModalModule,
    NgbPaginationModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    FormsModule,
    NgMultiSelectDropDownModule.forRoot(),
    LoadingBarHttpClientModule,
  ],
  declarations: [
    OffersGroupReportComponent,
    OffersReportComponent,
    MeetingGroupReportComponent,
    MeetingReportComponent,
    CombinedGroupReportComponent,
    RecommendationGroupReportComponent
  ]
})
export class ReportPanelModule { }
